// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1BZt2","info":"UpdateTermsInfo_info__cQFC2"};